import React, { useEffect } from "react";
import Hero from "./../../components/UserSideComponents/Home/Hero";

import Category from "../../components/UserSideComponents/Home/Category";
import About from "../../components/UserSideComponents/Home/About";
import Service from "../../components/UserSideComponents/Home/Service";
import Products from "../../components/UserSideComponents/Home/Products";
import PeopleChooseUs from "../../components/UserSideComponents/Home/PeopleChooseUs";
import Quality from "../../components/UserSideComponents/Home/Quality";
import Testimonial from "../../components/UserSideComponents/Home/Testimonial";
import Blog from "../../components/UserSideComponents/Home/Blog";

const Home = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      <Hero />
      <Category />
      <About />
      <Service />
      <Products />
      <PeopleChooseUs />
      <Quality />
      <Testimonial />
      <Blog />
    </>
  );
};

export default Home;
